import Vue from 'vue';
import Router from 'vue-router';
import { authService } from './plugins/firebase';


const requireAuth = async (to, from, next) => {
  if (await authService.authenticated()) {
    next();
  } else {
    next('/login');
  }
};

const routes = [];
routes.push({ path: '/', redirect: '/home' });
routes.push({ path: '/login', component: () => import('./pages/Login.vue') });
routes.push({ path: '/home', component: () => import('./pages/Home.vue'), beforeEnter: requireAuth });
routes.push({ path: '/lesson/:module/:id', name: 'lesson', component: () => import('./pages/Lesson.vue'), beforeEnter: requireAuth });
routes.push({ path: '/training', name: 'training', component: () => import('./pages/Training.vue'), beforeEnter: requireAuth });
routes.push({ path: '/conversation/:conversation', name: 'conversation', component: () => import('./pages/Conversation.vue'), beforeEnter: requireAuth });
routes.push({ path: '/payment', component: () => import('./pages/Payment.vue'), beforeEnter: requireAuth });
routes.push({ path: '/page/:page', component: () => import('./pages/Page.vue'), beforeEnter: requireAuth });
routes.push({ path: '/notifications', component: () => import('./pages/Notifications.vue'), beforeEnter: requireAuth });
routes.push({ path: '/plan', component: () => import('./pages/Plan.vue'), beforeEnter: requireAuth });
routes.push({ path: '/account', component: () => import('./pages/Account.vue'), beforeEnter: requireAuth });
routes.push({ path: '/chat', component: () => import('./pages/Chat.vue'), beforeEnter: requireAuth });


Vue.use(Router);
export default new Router({
  mode: 'history',
  routes
});
